import React from 'react';
import PropTypes from 'prop-types';

import { withClientConfig } from '@spotahome/soyuz/client';

import cityToggleConfig from '@common/config/cityToggleConfig';
import isFeatureDateToggleEnabled from '@common/utils/featureDateToggle';

import hideCancellationPoliciesShape from '@sru/shapes/hideCancellationPolicies';

import NoDepositBanner from '@search/components/NoDepositBanner';
import FreeCancellationBanner from '@search/components/FreeCancellationBanner';

const SearchBanner = ({
  cityId,
  cancellationPolicies,
  moveIn,
  clientConfig: {
    featureToggle: { hideCancellationPolicies }
  }
}) => {
  if (cityToggleConfig(cityId).isNoDepositSupported) {
    return <NoDepositBanner />;
  }
  if (!isFeatureDateToggleEnabled(hideCancellationPolicies)) {
    return (
      <FreeCancellationBanner
        moveIn={moveIn}
        cancellationPolicies={cancellationPolicies}
      />
    );
  }
  return null;
};

SearchBanner.propTypes = {
  cityId: PropTypes.string.isRequired,
  cancellationPolicies: PropTypes.shape({}),
  moveIn: PropTypes.string,
  clientConfig: PropTypes.shape({
    featureToggle: PropTypes.shape({
      ...hideCancellationPoliciesShape
    })
  }).isRequired
};

SearchBanner.defaultProps = {
  cancellationPolicies: {},
  moveIn: null
};

export default withClientConfig()(SearchBanner);
